<div class="main-nav-flyout">
    <div class="nav-header">
        <ul>
            <li *ngIf="isMobileApp()" class="nav-col" >
                <a href="com.huronaccelerators-mobile:/device-preferences"><span class="icon-checklist"></span> Device Preferences</a>
            </li>
            <li *ngFor="let link of headers">
                <a (click)="this.headerLinkClicked.emit(link)">
                    <span class="icon {{ link.iconClass }}"></span> {{ link.name }}
                </a>
            </li>
        </ul>
        <a class="close" (click)="closeMenu.emit()"><span class="icon-cross"></span></a>
    </div>
    <div class="nav-body">
        <ul class="main-nav-list">            
            <li class="nav-col" *ngFor="let section of (selectedHeader ? selectedHeader.sections : [])">
                <ul>
                    <li>
                        <a *ngIf="section.route" [routerLink]="['/' + section.route]" [fragment]="section.fragment">
                            <span [class]="section.iconClass"></span> {{ section.name }}
                        </a>
                        <span *ngIf="!section.route">
                            <span [class]="section.iconClass"></span> {{ section.name }}
                        </span>
                        <ul>
                            <li *ngFor="let item of section.items">
                                <a *ngIf="item.route && !item.isExternalRoute" [routerLink]="['/' + item.route]" [fragment]="item.fragment" (click)="navLinkClicked.emit()">
                                    {{ item.name }}
                                </a>
                                <a *ngIf="item.isExternalRoute" [href]="item.route" (click)="navLinkClicked.emit()">
                                    {{ item.name }}
                                </a>
                                <span *ngIf="!item.route" (click)="navLinkClicked.emit()">
                                    {{ item.name }}
                                </span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>            
        </ul>
        <ul class="app-list" *ngIf="applications.length > 0">
            <li *ngFor="let link of applications" >
                <a href="{{ link.route }}" (click)="navLinkClicked.emit()">
                    <span class="icon {{ link.iconClass }}"></span>{{ link.name }}
                </a>
            </li>
        </ul>
    </div>
  